import { makeService } from './api';

const service = makeService('positions');

export default service;